import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  Divider,
  Autocomplete,
  TextField,
  FormControlLabel,
  Checkbox,
  Radio,
  Stack,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import CloseIcon from "@mui/icons-material/Close";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import {
  getLeaveType,
  getUserLeaveDetail,
  postLeave,
} from "../../services/leaveManagement.service";
import { getPublicHoliday } from "../../services/publicHoliday.service";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import RefreshIcon from "@mui/icons-material/Refresh";
import { encryptData } from "../../utils/cryptoUtils";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../context/AuthProvider";
const ApplyLeave = (props) => {
  const { setOpenDrawer, formType, selectedData, GetData, GetLeaveData } =
    props;
  const disabled = formType === "view";
  const { accessToken } = useAuth();

  const formRef = useRef(null);
  const [leaveTypeData, setLeaveTypeData] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState([]);
  const [publicHolidayData, setPublicHolidayData] = useState([]);
  const [initialValues, setInitialValues] = useState({
    startDate: "",
    endDate: "",
    leaveType: "",
    reason: "",
    // publicHolidayId: "",
  });
  const [dateValues, setDateValues] = useState({
    startDate: null,
    endDate: null,
  });
  const [selectedDates, setSelectedDates] = useState([]);
  const [leaveCount, setLeaveCount] = useState({});


  // const userId = localStorage.getItem("_id");
  const validationSchema = Yup.object().shape({
    startDate: Yup.date().required("Select Start Date").nullable(),
    endDate: Yup.date().required("Select End Date").nullable(),
    leaveType: Yup.string().required("Select Leave Type"),
    // publicHolidayId: Yup.string().required("Select Public Holiday"),
    reason: Yup.string().required("Enter Reason"),
  });

  //decodeToken
  const getUserIdFromToken = () => {
    // const token = localStorage.getItem("token");
    if (!accessToken) return null;

    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };
  const userId = getUserIdFromToken();

  const GetLeaveTypeData = async () => {
    try {
      const res = await getLeaveType();
      const configData = res.data.data.map((e) => {
        return {
          ...e,
          label: e.name,
        };
      });
      return configData;
    } catch (error) {
      console.log(error);
    }
  };

  const getUserLeaveDetailData = async (userId) => {
    try {
      const res = await getUserLeaveDetail(userId);
      const availableLeave = res?.data?.availableLeave;
      setLeaveCount(availableLeave);

      const leaveTypes = await GetLeaveTypeData();
      const filteredLeaveTypes = leaveTypes.filter((leaveType) => {
        const leaveKey = leaveType.name
          .toLowerCase()
          .replace(/\s+(.)/g, (match, letter) => letter.toUpperCase())
          .replace(/\s+/g, "");
        // return availableLeave[leaveKey] > 0;
        const isAvailable = availableLeave[leaveKey] > 0;

        if (leaveKey === "lop") {
          return true;
        }

        return isAvailable;
      });
      setLeaveTypeData(filteredLeaveTypes);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserLeaveDetailData(userId);
  }, [userId]);

  const GetPublicHolidayData = async () => {
    try {
      const currentYear = new Date().getFullYear();
      const res = await getPublicHoliday({
        year: currentYear,
        type: "Upcoming",
      });
      const configData = res.data.data.map((e) => {
        return {
          ...e,
          label: e.name,
        };
      });
      setPublicHolidayData(configData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetLeaveTypeData();
    GetPublicHolidayData();
    if (formType === "edit" || formType === "view") {
      setInitialValues({
        name: selectedData.name || "",
        leaveType: selectedData.leaveType || "",
        reason: selectedData.reason || "",
        startDate: selectedData.startDate || "",
        endDate: selectedData.endDate || "",
        // publicHolidayId: selectedData?.publicHolidayId || "",
      });
    }
  }, [formType, selectedData]);

  const handleAddDates = () => {
    if (dateValues.startDate && dateValues.endDate) {
      const start = dayjs(dateValues.startDate);
      const end = dayjs(dateValues.endDate);
      const allDates = [];
      let currentDate = start;

      while (currentDate.isBefore(end) || currentDate.isSame(end, "day")) {
        allDates.push(currentDate.format("DD-MM-YYYY"));
        currentDate = currentDate.add(1, "day");
      }

      setSelectedDates(allDates);
    }
  };

  const [selectedValues, setSelectedValues] = useState(
    selectedDates.reduce((acc, date) => {
      acc[date] = "";
      return acc;
    }, {})
  );
  const transformedValues = Object.entries(selectedValues).map(
    ([date, type]) => {
      const [day, month, year] = date.split("-");
      if (
        !day ||
        !month ||
        !year ||
        isNaN(day) ||
        isNaN(month) ||
        isNaN(year)
      ) {
        console.error(`Invalid date value: ${date}`);
        return {
          date: null,
          type: type,
        };
      }

      const formattedDate = `${year}-${month}-${day}`;
      const parsedDate = new Date(formattedDate);

      if (isNaN(parsedDate.getTime())) {
        console.error(`Invalid date value: ${date}`);
        return {
          date: null,
          type: type,
        };
      }

      const isoDate = parsedDate.toISOString();

      return {
        date: isoDate,
        type: type,
      };
    }
  );

  const handleRadioChange = (date, value) => {
    setSelectedValues((prev) => ({
      ...prev,
      [date]: value,
    }));
  };

  useEffect(() => {
    if (dateValues.startDate && dateValues.endDate) {
      handleAddDates();
    }
  }, [dateValues.startDate, dateValues.endDate]);

  const onSubmit = async (values) => {
    try {
      // const id = localStorage.getItem("_id");
      const id = getUserIdFromToken();
      const startDate = dayjs(dateValues?.startDate).toISOString();
      const endDate = dayjs(dateValues?.endDate).toISOString();
      const leaveDays = transformedValues;

      const encryptedLeaveType = encryptData(values.leaveType);
      const encryptedReason = encryptData(values.reason);

      const apiMethod = postLeave(id, {
        ...values,
        startDate,
        endDate,
        leaveDays,
        leaveType: encryptedLeaveType,
        reason: encryptedReason,
      });
      const res = await apiMethod;
      ToastSuccess(res.message);
      setOpenDrawer(false);
      GetData();
      GetLeaveData(userId);
    } catch (error) {
      ToastError(error?.data?.message);
      setSelectedValues({});
    }
  };

  return (
    <div className="addRenderingPopup">
      <Box className="addContainerHeader">
        <Typography className="headerTitle">
          {formType === "edit" ? "Edit" : "Apply"} Leave
        </Typography>
        <CloseIcon
          className="Close-Icon"
          onClick={() => setOpenDrawer(false)}
        />
      </Box>
      <Divider sx={{ opacity: 1 }} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {({ touched, errors, values, setFieldValue }) => (
          <Form>
            <Box className="addContainerCenter" mb={1}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} mt={1}>
                  <div className="wsh-form-control">
                    <Typography className="inputLabel">
                      Leave Type <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Autocomplete
                      options={leaveTypeData}
                      value={
                        leaveTypeData.find(
                          (option) => option.name === values.leaveType
                        ) || null
                      }
                      onChange={(e, v) => {
                        setFieldValue("leaveType", v?.name);
                        setSelectedLeaveType(v ? [v.name] : []);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          focused={false}
                          placeholder="Select Leave Type"
                          className="AutoComplete_InputBox"
                        />
                      )}
                    />
                    <div className="form-error">
                      {touched.leaveType &&
                        errors.leaveType &&
                        errors.leaveType}
                    </div>
                  </div>
                </Grid>
                {selectedLeaveType === "Public Holiday" ? (
                  <Grid item xs={12} sm={6} mt={1}>
                    <div className="wsh-form-control">
                      <Typography className="inputLabel">
                        Public Holiday <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Autocomplete
                        options={publicHolidayData}
                        value={
                          publicHolidayData.find(
                            (option) => option._id === values.publicHolidayId
                          ) || null
                        }
                        // isOptionEqualToValue={(option, value) =>
                        //   option.id === value.id
                        // }
                        // value={
                        //   leaveOptions.find(
                        //     (option) => option.name === values.leaveType
                        //   ) || null
                        // }
                        onChange={(e, v) =>
                          setFieldValue("publicHolidayId", v?._id)
                        }
                        // onChange={(e, v) => setFieldValue("leaveType", v)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            focused={false}
                            placeholder="Select Festival"
                            className="AutoComplete_InputBox"
                          />
                        )}
                      />
                      <div className="form-error">
                        {touched.publicHolidayId &&
                          errors.publicHolidayId &&
                          errors.publicHolidayId}
                      </div>
                    </div>
                  </Grid>
                ) : (
                  <>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Leave Reason <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Field
                        name="reason"
                        className="InputField w-100"
                        placeholder="Enter Reason"
                        disabled={disabled}
                      />
                      <div className="form-error">
                        {touched.reason && errors.reason && errors.reason}
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        Start Date <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            value={
                              dateValues.startDate
                                ? dayjs(dateValues.startDate)
                                : null
                            }
                            onChange={(date) => {
                              setDateValues({
                                ...dateValues,
                                startDate: date ? date.toISOString() : null,
                              });
                              setFieldValue(
                                "startDate",
                                date ? date.toISOString() : null
                              ); // Ensure Formik is updated
                            }}
                            className="datePicker w-100"
                            disabled={disabled}
                            format="DD/MM/YYYY"
                            slotProps={{
                              popper: {
                                placement: "right",
                              },
                            }}
                            slots={{
                              openPickerIcon: CalendarTodayRoundedIcon,
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div className="form-error">
                        {touched.startDate &&
                          errors.startDate &&
                          errors.startDate}
                      </div>
                    </Grid>

                    {/* End Date Field */}
                    <Grid item xs={12} sm={6} mt={1}>
                      <Typography className="inputLabel">
                        End Date <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker"]}>
                          <DatePicker
                            value={
                              dateValues.endDate
                                ? dayjs(dateValues.endDate)
                                : null
                            }
                            onChange={(date) => {
                              setDateValues({
                                ...dateValues,
                                endDate: date ? date.toISOString() : null,
                              });
                              setFieldValue(
                                "endDate",
                                date ? date.toISOString() : null
                              ); // Ensure Formik is updated
                            }}
                            className="datePicker w-100"
                            disabled={disabled}
                            format="DD/MM/YYYY"
                            minDate={
                              dateValues.startDate
                                ? dayjs(dateValues.startDate)
                                : null
                            }
                            slotProps={{
                              popper: {
                                placement: "left",
                              },
                            }}
                            slots={{
                              openPickerIcon: CalendarTodayRoundedIcon,
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div className="form-error">
                        {touched.endDate && errors.endDate && errors.endDate}
                      </div>
                    </Grid>

                    {selectedDates.length > 0 && (
                      <Grid item xs={12} mt={2} ml={2}>
                        <Stack
                          direction={"row"}
                          justifyContent={"space-between"}
                          mb={2}
                        >
                          <Typography
                            sx={{ fontWeight: "14px", fontWeight: 700 }}
                          >
                            Selected Duration{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: "14px",
                              fontWeight: 500,
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "13%",
                            }}
                            onClick={() => {
                              setSelectedValues({});
                            }}
                          >
                            <RefreshIcon
                              sx={{
                                height: "15px",
                                width: "15px",
                                marginRight: "3px",
                              }}
                            />
                            Reset
                          </Typography>
                        </Stack>
                        {selectedDates.map((date, index) => (
                          <Box
                            key={index}
                            display="flex"
                            alignItems="center"
                            gap={2}
                          >
                            <Typography sx={{ width: "17%" }}>
                              {date}
                            </Typography>
                            <FormControlLabel
                              control={
                                <Radio
                                  sx={{
                                    color:
                                      selectedValues[date] === "Full Day"
                                        ? "#008080"
                                        : "default",
                                    "&.Mui-checked": {
                                      color: "#008080",
                                    },
                                  }}
                                  checked={selectedValues[date] === "Full Day"}
                                  onChange={() =>
                                    handleRadioChange(date, "Full Day")
                                  }
                                  name={`timeSelection-${date}`} // Ensure unique name per date
                                />
                              }
                              label="Full Day"
                            />
                            <FormControlLabel
                              control={
                                <Radio
                                  sx={{
                                    color:
                                      selectedValues[date] === "First Half"
                                        ? "#008080"
                                        : "default",
                                    "&.Mui-checked": {
                                      color: "#008080",
                                    },
                                  }}
                                  checked={
                                    selectedValues[date] === "First Half"
                                  }
                                  onChange={() =>
                                    handleRadioChange(date, "First Half")
                                  }
                                  name={`timeSelection-${date}`} // Ensure unique name per date
                                />
                              }
                              label="First Half"
                            />
                            <FormControlLabel
                              control={
                                <Radio
                                  sx={{
                                    color:
                                      selectedValues[date] === "Second Half"
                                        ? "#008080"
                                        : "default",
                                    "&.Mui-checked": {
                                      color: "#008080",
                                    },
                                  }}
                                  checked={
                                    selectedValues[date] === "Second Half"
                                  }
                                  onChange={() =>
                                    handleRadioChange(date, "Second Half")
                                  }
                                  name={`timeSelection-${date}`} // Ensure unique name per date
                                />
                              }
                              label="Second Half"
                            />
                          </Box>
                        ))}
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
            </Box>
            <Divider sx={{ opacity: 1 }} />
            <Grid className="addboxFooter">
              <Button
                className="cancelButton"
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="saveButton"
                sx={{ display: disabled ? "none" : "flex" }}
              >
                Request
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ApplyLeave;
